import React from 'react'
import cx from 'classnames'
import { oneOf, string } from 'prop-types'

import { SortDirectionIcon } from '@wf-sl/common-icons'

import styles from './sort-direction-indicator.module.css'

const SORT_INDICATOR_DIRECTIONS = {
    ASCENDING: 'asc',
    DESCENDING: 'desc',
    UNSORTED: 'unsorted'
}

const propTypes = {
    className: string,
    direction: oneOf(Object.values(SORT_INDICATOR_DIRECTIONS))
}

function SortDirectionIndicator({ className, direction = SORT_INDICATOR_DIRECTIONS.UNSORTED }) {
    const { ASCENDING, DESCENDING, UNSORTED } = SORT_INDICATOR_DIRECTIONS

    return (
        <SortDirectionIcon
            className={cx(styles['indicator'], className, 't3sel-sort-indicator', {
                ['t3sel-unsorted']: direction === UNSORTED,
                ['t3sel-sorted-asc']: direction === ASCENDING,
                [styles['asc']]: direction === ASCENDING,
                ['t3sel-sorted-desc']: direction === DESCENDING,
                [styles['desc']]: direction === DESCENDING
            })}
            height={12}
        />
    )
}

SortDirectionIndicator.propTypes = propTypes

export { SortDirectionIndicator, SORT_INDICATOR_DIRECTIONS }
